'use client';

import { c as _c } from "react/compiler-runtime";
import { InfoTooltip } from '@morpho-org/ui-v6/client';
import { memo, Suspense } from 'react';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';
import { VaultRatingsError, VaultRatingsLoading } from './states';
export interface VaultRatingsLayoutProps {
  slot: React.ReactNode;
}
const VaultRatingsLayout = t0 => {
  const $ = _c(6);
  const {
    slot
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SubSectionTitle>Ratings</SubSectionTitle>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="gap-2xs flex items-center">{t1}<InfoTooltip tooltipContent={<>Ratings are provided independently by third-parties and are not defined by Morpho.</>} className="text-secondary-foreground" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VaultRatingsError />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <VaultRatingsLoading />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== slot) {
    t5 = <div className="gap-sm flex flex-col items-start">{t2}<SectionErrorBoundary fallback={t3}><Suspense fallback={t4}>{slot}</Suspense></SectionErrorBoundary></div>;
    $[4] = slot;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default memo(VaultRatingsLayout);